import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import ClickAwayListener from 'react-click-away-listener';

const PopoverContent = ({ isVisible, children }) => {
  if(!isVisible) {
    return null;
  }

  return (
    <div className="cavs-popover__content white z-depth-2">
      {children}
    </div>
  )
};

const PopoverTitle = (props) => {
  return (
    <h3 className="cavs-popover__title">{props.children}</h3>
  );
};

const PopoverBody = (props) => {
  return (
    <p className="cavs-popover__body">{props.children}</p>
  );
};

const Popover = (props) => {
  const { triggerText } = props;
  const [isVisible, setIsVisible] = useState(false);

  const handleClick = useCallback((e) => {
    e.preventDefault();
    setIsVisible(!isVisible);
  }, [isVisible]);

  const handleClickAway = useCallback(() => {
    setIsVisible(false);
  }, [isVisible]);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className="cavs-popover">
          <Link to="#" className="secondary-text-color" onClick={handleClick}>
            {triggerText}
          </Link>
          <PopoverContent isVisible={isVisible}>
            {props.children}
          </PopoverContent>
      </div>
    </ClickAwayListener>
  );
};

Popover.Title = PopoverTitle;
Popover.Body = PopoverBody;

export default Popover;
